import { Link } from 'react-router-dom';
import { Building2, CreditCard } from 'lucide-react';

export function AdminPage() {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-foreground">Admin</h2>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Link
          to="/admin/departments"
          className="rounded-lg border border-border bg-card p-6 shadow-sm transition-all hover:-translate-y-0.5 hover:border-primary/40 hover:shadow-md"
        >
          <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-md bg-background text-primary">
            <Building2 size={20} strokeWidth={1.5} />
          </div>
          <h3 className="text-lg font-medium text-foreground">Departments</h3>
          <p className="mt-1 text-sm text-muted-foreground">
            Manage Kaopiz departments — codes, names, monthly budgets.
          </p>
        </Link>
        <Link
          to="/admin/cards"
          className="rounded-lg border border-border bg-card p-6 shadow-sm transition-all hover:-translate-y-0.5 hover:border-primary/40 hover:shadow-md"
        >
          <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-md bg-background text-primary">
            <CreditCard size={20} strokeWidth={1.5} />
          </div>
          <h3 className="text-lg font-medium text-foreground">Cards</h3>
          <p className="mt-1 text-sm text-muted-foreground">
            Register credit cards (bank + last 4 + alias) so ingest can resolve them.
          </p>
        </Link>
      </div>
    </div>
  );
}
